import React, { useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'

interface IEmailInputProps {
  defaultValue?: string
  placeholder?: string
  maxLength?: number
  isRequired?: boolean
  onChange: (value: string) => void
  onEntered?: (value: string) => void
  style?: React.CSSProperties
}

const EmailInput: React.FC<IEmailInputProps> = ({
  defaultValue,
  placeholder,
  maxLength,
  isRequired,
  onChange,
  onEntered,
  style,
}) => {
  const [value, setValue] = useState<string>(defaultValue || '')
  const [isValid, setIsValid] = useState(true)

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value
      const reg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
      setValue(newValue)
      if (reg.test(newValue) || newValue === '') {
        setIsValid(true)
        onChange(newValue)
      } else {
        setIsValid(false)
      }
    },
    [onChange]
  )

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (onEntered && event.key === 'Enter' && isValid) onEntered(value)
    },
    [onEntered, value, isValid]
  )

  const handleBlur = useCallback(() => {
    if (onEntered && isValid) onEntered(value)
  }, [onEntered, value, isValid])

  return (
    <Form.Control
      value={value}
      type='text'
      placeholder={placeholder}
      maxLength={maxLength}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      style={style}
      className={
        isRequired ? (!value ? 'is-invalid' : 'is-valid') : isValid ? '' : 'is-invalid'
      }
    />
  )
}
export default EmailInput
